import { ClickablePopoverMenu } from './ClickablePopoverMenu';
export default ClickablePopoverMenu;
